module.exports = __webpack_public_path__ + "img/logo.7ddabe25.png";